import { render, staticRenderFns } from "./EditDisManage.vue?vue&type=template&id=4df8375c&"
import script from "./EditDisManage.vue?vue&type=script&lang=js&"
export * from "./EditDisManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports